import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import {
  GeneralSettingsApi,
  PortionAosObservablesApi,
  PortionsApi,
} from "@socotec.io/atm-back-sdk";
import { listAllPages } from "@/api/utils/sdk";

const api = new PortionsApi(atmBackConfiguration);
const generalSettingsApi = new GeneralSettingsApi(atmBackConfiguration);
const portionAosObservablesApi = new PortionAosObservablesApi(atmBackConfiguration);

export const fetchGeneralSettings = async ({ caseInfo } = {}) => {
  return await generalSettingsApi.list({ caseInfo });
};

export const createGeneralSettings = async (generalSettingsData, currentCase) => {
  return await generalSettingsApi.create({
    generalSettingsRequest: { ...generalSettingsData, caseInfo: currentCase.atmUuid },
  });
};

export const updateGeneralSettings = async (generalSettingsData, currentCase) => {
  return await generalSettingsApi.update({
    uuid: generalSettingsData.uuid,
    generalSettingsRequest: { ...generalSettingsData, caseInfo: currentCase.atmUuid },
  });
};

export const fetchPortion = async ({ caseInfo, page, pageSize } = {}) => {
  return await api.list({ caseInfo, page, pageSize });
};

export const fetchAllPortion = async ({ caseInfo } = {}) => {
  return await listAllPages((page) => api.list({ caseInfo, page }));
};

export const retrievePortion = async (portionUuid) => {
  return await api.retrieve({ uuid: portionUuid });
};

export const createPortion = async (portionData, currentCase) => {
  return await api.create({
    portionRequest: { ...portionData, caseInfo: currentCase.atmUuid },
  });
};

export const updatePortion = async (portionData, currentCase) => {
  const portion = { ...portionData, caseInfo: currentCase.atmUuid };
  if (!portionData.measurementDocumentUuid) {
    portion.measurementDocumentUuid = null;
  }
  return await api.update({ uuid: portionData.uuid, portionRequest: portion });
};

export const BulkUpdatePortionMaterials = async ({ portionUuid, materialsUuids }) => {
  return await api.materials({
    uuid: portionUuid,
    portionMaterialsRequest: { materialsUuids },
  });
};

export const BulkUpdatePortionContributors = async ({ portionUuid, contributorsUuids }) => {
  return await api.contributors({
    uuid: portionUuid,
    portionContributorsRequest: { contributorsUuids },
  });
};

export const BulkUpdatePortionCompanies = async ({ portionUuid, companiesUuids }) => {
  return await api.companies({
    uuid: portionUuid,
    portionCompaniesRequest: { companiesUuids },
  });
};

export const destroyPortion = async (portionUuid) => {
  await api.destroy({ uuid: portionUuid });
};

export const fetchPortionObservable = async ({ portion } = {}) => {
  return await listAllPages((page) => portionAosObservablesApi.list({ portion, page }));
};

export const batchCreateOrDeletePortionObservables = async ({ portionUuid, aosItems }) => {
  const response = await api.aosObservables({
    uuid: portionUuid,
    portionAosObservablesRequest: { aosItems },
  });
  return response.results;
};
